// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__11uLy","right":"styles_right__28X97"};